import React from "react";

import { colors } from "@zapalacorp/tokens";

import { DocumentBadge } from "./styles";

export enum BadgeType {
  SUCCESS = "success",
  NEUTRAL = "neutral",
  ERROR = "error",
}

interface DocumentsBadgeProps {
  type?: BadgeType;
  text: string;
}

const generateColorObject = (color: string, backgroundColor: string) => ({
  color,
  backgroundColor,
});

const badgeColors = {
  [BadgeType.SUCCESS]: generateColorObject(colors.success600, colors.success50),
  [BadgeType.NEUTRAL]: generateColorObject(colors.gray600, colors.gray50),
  [BadgeType.ERROR]: generateColorObject(colors.error600, colors.error50),
};

export const DocumentsBadge = ({ type = BadgeType.NEUTRAL, text }: DocumentsBadgeProps) => {
  return <DocumentBadge {...badgeColors[type]}>{text}</DocumentBadge>;
};
